import React from "react";
import { IntegrationInterfaceCompanyResponse } from "@/main/models/response";
import { TableCell } from "@mui/material";
import StatusIntegrationCompany from "@/main/components/shared/status/statusIntegrationCompany";
import { convertStringForBoolean } from "@/main/services/utilsString";
import { StatusIntegrationCompanyEnum } from "@/main/services/enum/StatusIntegrationCompanyEnum";
import { getOptionsStatusIntegrationCompany } from "@/main/services/data/data";
import { useNavigate } from "react-router-dom";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { buildUrlQueryParams } from "@/main/services/utils";
import * as S from "./styles";

interface IRowDataIntegrationCompanyProps {
	integrationInterfaceCompany: IntegrationInterfaceCompanyResponse;
}

function RowDataIntegrationCompany({ integrationInterfaceCompany }: IRowDataIntegrationCompanyProps) {
	const navigate = useNavigate();

	function handleClickRow(e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) {
		e.preventDefault();
		e.stopPropagation();
		const redirectRoute = buildUrlQueryParams(RoutesConstants.integrationRegister, {
			guidIntegrationCompany: integrationInterfaceCompany.guid,
		});
		navigate(redirectRoute);
	}

	const optionsStatus = getOptionsStatusIntegrationCompany();
	const statusFormatted = convertStringForBoolean(integrationInterfaceCompany.status)
		? optionsStatus.find((item) => item.key === StatusIntegrationCompanyEnum.Active)!
		: optionsStatus.find((item) => item.key === StatusIntegrationCompanyEnum.Suspended)!;

	return (
		<S.Container $isSizeLong onClick={handleClickRow}>
			<S.EllipsisCell title={integrationInterfaceCompany.companyType}>
				{integrationInterfaceCompany.companyType}
			</S.EllipsisCell>
			<S.EllipsisCell title={integrationInterfaceCompany.companyName}>
				{integrationInterfaceCompany.companyName}
			</S.EllipsisCell>
			<S.EllipsisCell title={integrationInterfaceCompany.service}>{integrationInterfaceCompany.service}</S.EllipsisCell>
			<S.EllipsisCell title={integrationInterfaceCompany.interface}>
				{integrationInterfaceCompany.interface}
			</S.EllipsisCell>
			<S.EllipsisCell title={integrationInterfaceCompany.endpoint}>
				{integrationInterfaceCompany.endpoint}
			</S.EllipsisCell>
			<TableCell>
				<StatusIntegrationCompany idStatus={statusFormatted.key} name={statusFormatted.value} />
			</TableCell>
		</S.Container>
	);
}

export default RowDataIntegrationCompany;
